import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap";
import { useSelector } from "react-redux";
import moment from "moment";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import { getCurrentAccount } from "../../../reducers/selectors";
import { fetchInProcesOrderPDF } from "../../../services/api/accounts";

import toggleIcon from "../../../../public/svg/x-symbol-svgrepo-com.svg";
import pdf from "../../../../public/svg/pdf.svg";

import style from "./AuthorizationModal.scss";

export const AuthorizationModal = ({ modal, toggle, authItem, onReject, onAuthorize }) => {
  const [order, setOrder] = useState(null);
  const currentAccount = useSelector(getCurrentAccount);

  useEffect(() => {
    if (authItem) {
      if (authItem.process === "Order") {
        const orderInfo = JSON.parse(authItem.info);
        orderInfo.currency = orderInfo.OrderCurrencySymbol;
        orderInfo.ammount = 0;

        switch (orderInfo.OrderType.trim()) {
          case "Market":
          case "MarketOnOpen":
          case "MarketOnClose":
            orderInfo.ammountString = "Mercado";
            break;
          case "Limit":
            orderInfo.ammountString = "Limit";
            orderInfo.ammount = orderInfo.OrderPrice;
            break;
          case "Stop":
            orderInfo.ammountString = "Stop";
            orderInfo.ammount = orderInfo.OrderStopPrice;
            break;
          case "StopLimit":
            orderInfo.ammountString = "Stop Limit";
            orderInfo.ammount = orderInfo.OrderStopPrice;
            break;
          default:
            break;
        }

        setOrder(orderInfo);
      }
    }
  }, [authItem]);

  const handleDownload = (order) => {
    fetchInProcesOrderPDF({
      orderId: order.OrderId,
      accountId: currentAccount.id,
    })
      .then(({ response }) => {
        if (response.result.Code !== 200) {
          showToast("Error obteniendo pdf del servidor", true);
        } else {
          var a = document.createElement("A");
          a.href = `data:application/octet-stream;base64,${response.blobfile}`;
          a.download = `${moment(order.OrderInitDate).format("DD-MM-YY")}-${order.OrderId}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <Modal size="lg" isOpen={modal} contentClassName={style.content}>
      <div className={style.modalWrapper}>
        <ModalHeader className={style.header}>
          <span className={style.titleContainer}>
            <p className={style.title}>Autorización</p>
            <img
              className={style.toggleIcon}
              src={toggleIcon}
              alt="X"
              onClick={() => {
                toggle();
              }}
            />
          </span>
          <p>Nueva orden - pedido de autorización de orden - pendiente</p>
        </ModalHeader>
        {authItem && order && (
          <ModalBody className={style.body}>
            <p className={style.bodyTitle}>Lado de la orden</p>
            <p className={style.bodySubTitle}>{order.OrderSide === "Buy" ? "Compra " : "Venta "}</p>

            <p className={style.bodyTitle}>Descripción de los valores</p>
            <p
              className={style.bodySubTitle}
            >{`${order.AssetTicker.trim()} - ${order.AssetDescription.trim()} `}</p>

            <p className={style.bodyTitle}>Valor nominal</p>
            <p className={style.bodySubTitle}>
              {order.ammount === 0 ? (
                "-"
              ) : (
                <FormattedNumber
                  value={order.ammount}
                  minimumFractionDigits={order.currency == "USD" ? 2 : 0}
                  maximumFractionDigits={order.currency == "USD" ? 2 : 0}
                />
              )}
            </p>

            <p className={style.bodyTitle}>Precio</p>
            <p className={style.bodySubTitle}>{order.ammountString}</p>

            <p className={style.bodyTitle}>ISIN</p>
            <p className={style.bodySubTitle}>{order.AssetISIN}</p>

            <p className={style.bodyTitle}>Cuenta</p>
            <p className={style.bodySubTitle}>{order.CurrentAccount.AccountNumber}</p>

            <p className={style.bodyTitle}>Fecha de la orden</p>
            <p className={style.bodySubTitle}>{moment(authItem.dateTime).format("DD/MM/YYYY")}</p>
          </ModalBody>
        )}
        <ModalFooter className={style.footer}>
          <Row className={style.buttonsWrapper}>
            <div className={style.buttonContainer}>
              <img src={pdf} className={style.icon} alt="pdf-icon" onClick={() => handleDownload(order)} />
              <Button
                className={style.button}
                onClick={() => {
                  onReject(authItem);
                  toggle();
                }}
              >
                rechazar
              </Button>
              <Button
                className={`${style.button} ${style.botonAutorizar}`}
                onClick={() => {
                  onAuthorize(authItem);
                  toggle();
                }}
              >
                autorizar
              </Button>
            </div>
          </Row>
          <Row className={style.disclaimersWrapper}>
            <div className={style.disclaimers}>
              <p>*De no completarse se considera válida por 30 días corridos</p>
              <p>Disclaimer</p>
              <p>Dejo constancia que recibo copia de las presentes instrucciones.</p>
            </div>
          </Row>
        </ModalFooter>
      </div>
    </Modal>
  );
};
